import { dmxConflicts } from '../../lighting/dmx.js';
import { defineRule } from '../rule.js';

/** E: fixtures share DMX addresses, or a fixture runs past channel 512 (OIL-14). */
export const dmxConflict = defineRule(
  'dmx-conflict',
  'error',
  { en: 'DMX address conflict', de: 'DMX-Adresskonflikt' },
  (data, emit) =>
    dmxConflicts(Object.values(data.items)).map((c) =>
      emit(c.itemIds, { universe: c.universe, kind: c.kind }),
    ),
);
